import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export function Settings() {
  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
        Settings
      </Typography>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          Settings Component
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This will contain system settings, user preferences, and configuration options.
        </Typography>
      </Paper>
    </Box>
  );
} 